import { Channel } from 'lane-shared/types/ChannelType';

export function isChannelType(channel: Partial<Channel>): channel is Channel {
  return (
    channel && '_id' in channel && 'name' in channel && 'settings' in channel
  );
}
